import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import { CSSTransition } from "react-transition-group";
import PerfectScrollbar from "react-perfect-scrollbar";
import { NavLink } from "react-router-dom";
import { Redirect, withRouter } from "../../utils/router-compat";
import { Nav, NavItem } from "reactstrap";
import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";
// services
import Storage from "../../services/Storage";
// import AuthService from "../../services/AuthService";
import DashboardService from "../../services/DashboardService";

// modal
import LogoutModal from "../../modal/LogoutModal/LogoutModal";
import DownloadScorcard from "../../components/DownloadScorcard/DownloadScorcard";

// css
import "./AppSidebar.css";

// action
import { setEnableMobileMenu } from "../../actions/ThemeAction";
// import OfftakeEntryService from "../../services/OfftakeEntryService";
// import { setUserDetail } from '../../actions/UserAction';

// utils
import { downlodFile } from "../../utils/utils";
import { Permissions } from "../../constants/constant.permissions";
import { Roles } from "../../constants/constant.role";
// constant
// import { messages } from '../../constants/constant.message';

// let modalButtons = [];

class AppSidebar extends Component {
  state = {
    navBarToHide: [],
    isLogoutModalOpen: false,
    redirectToLoginPage: false,
    isLoader: false,
    isScorCardOpen: false
  };

  isMobile = false;

  userDetail = {};

  isDisplayLogOut = false;

  constructor(props) {
    super(props);
    this.state = {
      activeNav: 100,
      redirectToLoginPage: false
    };
    this.userDetail = Storage.getUserDetail();
  }

  getActiveLink(tab) {
    if (this.state.activeNav !== tab) {
      this.setState({
        activeNav: tab
      });
    }
  }

  componentWillMount() {
    this.checkUserAgent();
  }

  componentDidMount() {
    this.checkUserAgent();
    this.navBarToHide();
  }

  navBarToHide = () => {
    DashboardService.navBarToHide()
      .then(data => {
        this.setState({
          navBarToHide: data.data.data.menu
        });
      })
      .catch(e => {
        console.error("e", e);
      });
  };

  toggleMobileSidebar = () => {
    const { enableMobileMenu, setEnableMobileMenu } = this.props;
    this.isDisplayLogOut = enableMobileMenu;
    setEnableMobileMenu(!enableMobileMenu);
  };
  isScorCardOpen;

  openLogoutModal = () => {
    this.setState({ isLogoutModalOpen: true });
  };

  closeLogoutModal = () => {
    this.setState({ isLogoutModalOpen: false });
  };

  openScorcardModel = () => {
    this.setState({ isScorCardOpen: true });
  };

  closeScorcardModel = () => {
    this.setState({ isScorCardOpen: false });
  };

  downloadfleetreport = () => {
    this.setState({
      isLoader: true
    })
    DashboardService.downloadfleetreport()
      .then(data => {
        this.setState({
          isLoader: false
        })
        downlodFile(data.data.data.file);
      })
      .catch(e => {
        this.setState({
          isLoader: false
        })
        console.error("e", e);
      });
  };

  // logout = () => {

  //   AuthService.logout();
  //   this.props.setUserDetail(null);
  //   // Storage.removeKeepMeLoggedInCookie();
  //   // Storage.removeTokenDetail();
  //   // Storage.removeUserDetail();
  //   // // this.closeLogoutModal();
  //   this.props.history.replace("/login");
  // }

  // logoutFromAllDevice = () => {
  //   AuthService.logoutFromAllDevice()
  //     .then(data => {
  //       this.logout();
  //     })
  //     .catch(e => {
  //       this.logout();
  //     })
  // }

  checkUserAgent() {
    const ua = navigator.userAgent;
    this.isMobile = false;
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
        ua
      )
    ) {
      this.isMobile = true;
      return true;
    }
    if (/Chrome/i.test(ua)) {
      return false;
    }
    return false;
  }

  closeSidebar = () => {
    Storage.removeSelectedFmData();
    this.toggleMobileSidebar();

    // this.setState({
    // });
  };

  checkActive = (match, location) => {
    if (!match) {
      return false;
    }
    return true;
  };

  downloadScorecard = () => {
    this.setState({
      isLoader: true
    });
    let API;
    if (Storage.getUserDetail().type === Roles.HEAD_OFFICE_BAADSHAH_ROLE) {
      API = DashboardService.downloadHOScoreCard();
    } else {
      API = DashboardService.downloadScoreCard();
    }
    API.then(data => {
      this.setState({
        isLoader: false
      });
      const { file } = data.data.data;
      downlodFile(file);
    }).catch(e => {
      this.setState({
        isLoader: false
      });
      console.error("e", e);
    });
  };

  downloadScorecardMouseEvent = isHover => {
    let style = {
      fontSize: "16px"
    };
    if (isHover) {
      style = {
        fontSize: "16px",
        cursor: "pointer",
        textDecoration: "underline",
        color: "#0056b3"
      };
    }
    this.setState({ downloadScorecardStyle: style });
  };

  downloadfleetScorecardMouseEvent = isHover => {
    let style = {
      fontSize: "16px"
    };
    if (isHover) {
      style = {
        fontSize: "16px",
        cursor: "pointer",
        textDecoration: "underline",
        color: "#0056b3"
      };
    }
    this.setState({ downloadfleetScorecardStyle: style });
  };

  render() {
    const {
      backgroundColor = true,
      enableBackgroundImage = true,
      enableSidebarShadow = true,
      backgroundImage = true,
      backgroundImageOpacity = true,
      userDetail = {}
    } = this.props;
    const { downloadScorecardStyle, downloadfleetScorecardStyle } = this.state;

    const userRoleDetail = Storage.getUserDetail();

    let mainMenuArr = [
      {
        to: "/whats-new",
        defaultImage: "images/sidebar-icons/b_1.png",
        selectedImage: "images/sidebar-icons/b_2.png",
        title: "What’s New ?",
        isActive: false,
        key: "What’s New ?",
        permission: [Permissions.WHATS_NEW_BAADSHAH],
      },
      {
        to: "/dashboard",
        defaultImage: "images/sidebar-icons/ho-dashboard.svg",
        selectedImage: "images/sidebar-icons/ho-dashboard-selected.svg",
        title: "Dashboard",
        isActive: false,
        key: "Dashboard",
        permission: [Permissions.OFFTAKE_DASHBOARD_BAADSHAH],
      },
      {
        to: "/",
        defaultImage: "images/sidebar-icons/dashboard.svg",
        selectedImage: "images/sidebar-icons/dashboard-selected.svg",
        title: (userRoleDetail.type.toLowerCase() === Roles.ZONAL_FLEET_MANAGER_ROLE || userRoleDetail.type.toLowerCase() === Roles.HEAD_OFFICE_BAADSHAH_ROLE) ? "Point Dashboard" : "Dashboard",
        isActive: false,
        key: "Point Dashboard",
        permission: [Permissions.POINTS_DASHBOARD_BAADSHAH],
      },
      {
        to: "/report",
        defaultImage: "images/sidebar-icons/detail.svg",
        selectedImage: "images/sidebar-icons/detail-selected.svg",
        title: "Reports",
        isActive: false,
        key: "Reports",
        permission: [Permissions.OFFTAKE_REPORT_BAADSHAH],
      },
      {
        to: "/indirectBillingReport",
        defaultImage: "images/sidebar-icons/indirect-report.svg",
        selectedImage: "images/sidebar-icons/indirect-report-selected.svg",
        title: "Indirect Billing Report",
        isActive: false,
        key: " Indirect Billing Report",
        permission: [Permissions.INDIRECT_BILLING_REPORT],
      },
      {
        to: "/fleetDetails",
        defaultImage: "images/sidebar-icons/fleet-details.svg",
        selectedImage: "images/sidebar-icons/fleet-details-selected.svg",
        title: "Fleet Details",
        isActive: false,
        key: "Fleet Details",
        permission: [Permissions.FLEET_DETAIL],
      },
      {
        to: null,
        defaultImage: "images/sidebar-icons/download-scorecard.svg",
        selectedImage: "images/sidebar-icons/download-scorecard-selected.svg",
        title: "Download Scorecard",
        isActive: false,
        key: "Download ScoreCard",
        permission: [Permissions.DOWNLOAD_SCORECARD_BAADSHAH],
      },
      {
        to: null,
        defaultImage: "images/sidebar-icons/download-scorecard.svg",
        selectedImage: "images/sidebar-icons/download-scorecard-selected.svg",
        title: "Download Fleet Master",
        isActive: false,
        key: "Download Fleet Master",
        download_fleet_report: true,
        permission: [Permissions.DOWNLOAD_FLEET_MASTER],

      },
      {
        to: "/salesReport",
        defaultImage: "images/sidebar-icons/sales-report.svg",
        selectedImage: "images/sidebar-icons/sales-report-selected.svg",
        title: "Sales Report",
        isActive: false,
        key: "Sales Report",
        permission: [Permissions.SALES_REPORT],
      },
      {
        to: "/activity-report",
        defaultImage: "images/sidebar-icons/activity-report.svg",
        selectedImage: "images/sidebar-icons/activity-report-selected.svg",
        title: "Activity Report",
        isActive: false,
        key: "Activity Report",
        permission: [Permissions.ACTIVITY_REPORT],
      },
      {
        to: "/redemption-catalog",
        defaultImage: "images/sidebar-icons/gift-catalog-not-selected.png",
        selectedImage: "images/sidebar-icons/gift-catalog-selected.png",
        title: "Redemption Catalogue",
        isActive: false,
        key: "Redemption Catalogue",
        permission: [Permissions.REDEMPTION_CATALOGUE],
      },
      {
        to: "/new-fleet-registration",
        defaultImage: "images/sidebar-icons/NewFleetRegistration.svg",
        selectedImage: "images/sidebar-icons/NewFleetRegistrationslected.svg",
        title: "New Fleet Registration",
        isActive: false,
        key: "New Fleet Registration",
        permission: [Permissions.NEW_FLEET_REGISTRATION],
      },
      {
        to: "/addEditOfftakeEntry",
        defaultImage: "images/sidebar-icons/add-offtake-entry.svg",
        selectedImage: "images/sidebar-icons/add-offtake-entry-active.svg",
        title: "Add Offtake Entry",
        isActive: false,
        key: "Add Offtake Entry",
        permission: [Permissions.ADD_OFFTAKE_ENTRY],
      },
      {
        to: "/offtakeEntriesVerificationStatus",
        defaultImage: "images/sidebar-icons/detail.svg",
        selectedImage: "images/sidebar-icons/detail-selected.svg",
        title: "Offtake Verification Status",
        isActive: false,
        key: "Offtake Verification Status",
        permission: [Permissions.OFFTAKE_VERIFICATION_STATUS],
      },
      {
        to: "/about",
        defaultImage: "images/sidebar-icons/about.svg",
        selectedImage: "images/sidebar-icons/about-selected.svg",
        title: "About Programme",
        isActive: false,
        key: "About Programme",
        permission: [Permissions.ABOUT_PROGRAMME_BAADSHAH],
      },
      {
        to: "/cip-summary",
        defaultImage: "images/sidebar-icons/customer_interaction_ina.png",
        selectedImage: "images/sidebar-icons/customer_interaction.png",
        title: "Customer Interaction Program",
        isActive: false,
        key: "cip",
        permission: [Permissions.CUSTOMER_INTERACTION],
        // link_note: "CIP Registration and Summary"
      },
      {
        to: "/contact-us",
        defaultImage: "images/sidebar-icons/ContactUs.svg",
        selectedImage: "images/sidebar-icons/ContactsUsSelcted.svg",
        title: "Contact Us",
        isActive: false,
        key: "Contact Us",
        permission: [Permissions.CONTACT_US_BAADSHAH],
      }
    ];

    // var fleetSideMenus = [
    //   {
    //     to: "/whats-new",
    //     defaultImage: "images/sidebar-icons/b_1.png",
    //     selectedImage: "images/sidebar-icons/b_2.png",
    //     title: "What’s New ?",
    //     isActive: false,
    //     key: "What’s New ?",
    //     permission: [Permissions.WHATS_NEW_BAADSHAH],
    //   },
    //   {
    //     to: "/",
    //     defaultImage: "images/sidebar-icons/dashboard.svg",
    //     selectedImage: "images/sidebar-icons/dashboard-selected.svg",
    //     title: "Dashboard",
    //     isActive: false,
    //     key: "Dashboard",
    //     permission: [Permissions.POINTS_DASHBOARD_BAADSHAH],
    //   },
    //   {
    //     to: "/addEditOfftakeEntry",
    //     defaultImage: "images/sidebar-icons/add-offtake-entry.svg",
    //     selectedImage: "images/sidebar-icons/add-offtake-entry-active.svg",
    //     title: "Add Offtake Entry",
    //     isActive: false,
    //     key: "Add Offtake Entry",
    //     permission: [Permissions.ADD_OFFTAKE_ENTRY],
    //   },
    //   {
    //     to: "/offtakeEntriesVerificationStatus",
    //     defaultImage: "images/sidebar-icons/detail.svg",
    //     selectedImage: "images/sidebar-icons/detail-selected.svg",
    //     title: "Offtake Verification Status",
    //     isActive: false,
    //     key: "Offtake Verification Status",
    //     permission: [Permissions.OFFTAKE_VERIFICATION_STATUS],
    //   },
    //   {
    //     to: "/redemption-catalog",
    //     defaultImage: "images/sidebar-icons/gift-catalog-not-selected.png",
    //     selectedImage: "images/sidebar-icons/gift-catalog-selected.png",
    //     title: "Redemption Catalogue",
    //     isActive: false,
    //     key: "Redemption Catalogue",
    //     permission: [Permissions.REDEMPTION_CATALOGUE],
    //   },
    //   {
    //     to: "/about",
    //     defaultImage: "images/sidebar-icons/about.svg",
    //     selectedImage: "images/sidebar-icons/about-selected.svg",
    //     title: "About Programme",
    //     isActive: false,
    //     key: "About Programme",
    //     permission: [Permissions.ABOUT_PROGRAMME_BAADSHAH],
    //   },
    //   {
    //     to: "/contact-us",
    //     defaultImage: "images/sidebar-icons/ContactUs.svg",
    //     selectedImage: "images/sidebar-icons/ContactsUsSelcted.svg",
    //     title: "Contact Us",
    //     isActive: false,
    //     key: "Contact Us",
    //     permission: [Permissions.CONTACT_US_BAADSHAH],
    //   }
    // ];

    // var fleetManagerSideMenus = [
    //   {
    //     to: "/",
    //     defaultImage: "images/sidebar-icons/dashboard.svg",
    //     selectedImage: "images/sidebar-icons/dashboard-selected.svg",
    //     title: "Dashboard",
    //     isActive: false,
    //     key: "Dashboard",
    //     permission: [Permissions.POINTS_DASHBOARD_BAADSHAH],
    //   },
    //   {
    //     to: "/report",
    //     defaultImage: "images/sidebar-icons/detail.svg",
    //     selectedImage: "images/sidebar-icons/detail-selected.svg",
    //     title: "Reports",
    //     isActive: false,
    //     key: "Reports",
    //     permission: [Permissions.OFFTAKE_REPORT_BAADSHAH],
    //   },

    //   {
    //     to: "/indirectBillingReport",
    //     defaultImage: "images/sidebar-icons/indirect-report.svg",
    //     selectedImage: "images/sidebar-icons/indirect-report-selected.svg",
    //     title: "Indirect Billing Report",
    //     isActive: false,
    //     key: " Indirect Billing Report",
    //     permission: [Permissions.INDIRECT_BILLING_REPORT],
    //   },
    //   {
    //     to: "/fleetDetails",
    //     defaultImage: "images/sidebar-icons/fleet-details.svg",
    //     selectedImage: "images/sidebar-icons/fleet-details-selected.svg",
    //     title: "Fleet Details",
    //     isActive: false,
    //     key: "Fleet Details",
    //     permission: [Permissions.FLEET_DETAIL],
    //   },
    //   {
    //     to: null,
    //     defaultImage: "images/sidebar-icons/download-scorecard.svg",
    //     selectedImage: "images/sidebar-icons/download-scorecard-selected.svg",
    //     title: "Download Scorecard",
    //     isActive: false,
    //     key: "Download ScoreCard",
    //     permission: [Permissions.DOWNLOAD_SCORECARD_BAADSHAH],
    //   },
    //   {
    //     to: null,
    //     defaultImage: "images/sidebar-icons/download-scorecard.svg",
    //     selectedImage: "images/sidebar-icons/download-scorecard-selected.svg",
    //     title: "Download Fleet Master",
    //     isActive: false,
    //     key: "Download Fleet Master",
    //     download_fleet_report: true,
    //     permission: [Permissions.DOWNLOAD_FLEET_MASTER],

    //   },
    //   {
    //     to: "/salesReport",
    //     defaultImage: "images/sidebar-icons/sales-report.svg",
    //     selectedImage: "images/sidebar-icons/sales-report-selected.svg",
    //     title: "Sales Report",
    //     isActive: false,
    //     key: "Sales Report",
    //     permission: [Permissions.SALES_REPORT],
    //   },
    //   {
    //     to: "/activity-report",
    //     defaultImage: "images/sidebar-icons/activity-report.svg",
    //     selectedImage: "images/sidebar-icons/activity-report-selected.svg",
    //     title: "Activity Report",
    //     isActive: false,
    //     key: "Activity Report",
    //     permission: [Permissions.ACTIVITY_REPORT],
    //   },
    //   {
    //     to: "/redemption-catalog",
    //     defaultImage: "images/sidebar-icons/gift-catalog-not-selected.png",
    //     selectedImage: "images/sidebar-icons/gift-catalog-selected.png",
    //     title: "Redemption Catalogue",
    //     isActive: false,
    //     key: "Redemption Catalogue",
    //     permission: [Permissions.REDEMPTION_CATALOGUE],
    //   },
    //   {
    //     to: "/new-fleet-registration",
    //     defaultImage: "images/sidebar-icons/NewFleetRegistration.svg",
    //     selectedImage: "images/sidebar-icons/NewFleetRegistrationslected.svg",
    //     title: "New Fleet Registration",
    //     isActive: false,
    //     key: "New Fleet Registration",
    //     permission: [Permissions.NEW_FLEET_REGISTRATION],
    //   },
    //   {
    //     to: "/about",
    //     defaultImage: "images/sidebar-icons/about.svg",
    //     selectedImage: "images/sidebar-icons/about-selected.svg",
    //     title: "About Programme",
    //     isActive: false,
    //     key: "About Programme",
    //     permission: [Permissions.ABOUT_PROGRAMME_BAADSHAH],
    //   },
    //   {
    //     to: "/contact-us",
    //     defaultImage: "images/sidebar-icons/ContactUs.svg",
    //     selectedImage: "images/sidebar-icons/ContactsUsSelcted.svg",
    //     title: "Contact Us",
    //     isActive: false,
    //     key: "Contact Us",
    //     permission: [Permissions.CONTACT_US_BAADSHAH],
    //   }
    // ];

    // var zonalFleetManagerSideMenus = [
    //   {
    //     to: "/dashboard",
    //     defaultImage: "images/sidebar-icons/ho-dashboard.svg",
    //     selectedImage: "images/sidebar-icons/ho-dashboard-selected.svg",
    //     title: "Dashboard",
    //     isActive: false,
    //     key: "Dashboard",
    //     permission: [Permissions.OFFTAKE_DASHBOARD_BAADSHAH],
    //   },
    //   {
    //     to: "/",
    //     defaultImage: "images/sidebar-icons/dashboard.svg",
    //     selectedImage: "images/sidebar-icons/dashboard-selected.svg",
    //     title: " Point Dashboard",
    //     isActive: false,
    //     key: "Dashboard",
    //     permission: [Permissions.POINTS_DASHBOARD_BAADSHAH],
    //   },
    //   {
    //     to: "/report",
    //     defaultImage: "images/sidebar-icons/detail.svg",
    //     selectedImage: "images/sidebar-icons/detail-selected.svg",
    //     title: "Reports",
    //     isActive: false,
    //     key: "Reports",
    //     permission: [Permissions.OFFTAKE_REPORT_BAADSHAH],
    //   },
    //   {
    //     to: "/indirectBillingReport",
    //     defaultImage: "images/sidebar-icons/indirect-report.svg",
    //     selectedImage: "images/sidebar-icons/indirect-report-selected.svg",
    //     title: "Indirect Billing Report",
    //     isActive: false,
    //     key: " Indirect Billing Report",
    //     permission: [Permissions.INDIRECT_BILLING_REPORT],
    //   },
    //   {
    //     to: "/fleetDetails",
    //     defaultImage: "images/sidebar-icons/fleet-details.svg",
    //     selectedImage: "images/sidebar-icons/fleet-details-selected.svg",
    //     title: "Fleet Details",
    //     isActive: false,
    //     key: "Fleet Details",
    //     permission: [Permissions.FLEET_DETAIL],
    //   },
    //   {
    //     to: null,
    //     defaultImage: "images/sidebar-icons/download-scorecard.svg",
    //     selectedImage: "images/sidebar-icons/download-scorecard-selected.svg",
    //     title: "Download Scorecard",
    //     isActive: false,
    //     key: "Download Sales Report",
    //     permission: [Permissions.DOWNLOAD_SCORECARD_BAADSHAH],
    //   },
    //   {
    //     to: null,
    //     defaultImage: "images/sidebar-icons/download-scorecard.svg",
    //     selectedImage: "images/sidebar-icons/download-scorecard-selected.svg",
    //     title: "Download Fleet Master",
    //     isActive: false,
    //     key: "Download Fleet Master",
    //     download_fleet_report: true,
    //     permission: [Permissions.DOWNLOAD_FLEET_MASTER],
    //   },
    //   {
    //     to: "/salesReport",
    //     defaultImage: "images/sidebar-icons/sales-report.svg",
    //     selectedImage: "images/sidebar-icons/sales-report-selected.svg",
    //     title: "Sales Report",
    //     isActive: false,
    //     key: "Sales Report",
    //     permission: [Permissions.SALES_REPORT],
    //   },
    //   {
    //     to: "/activity-report",
    //     defaultImage: "images/sidebar-icons/activity-report.svg",
    //     selectedImage: "images/sidebar-icons/activity-report-selected.svg",
    //     title: "Activity Report",
    //     isActive: false,
    //     key: "Activity Report",
    //     permission: [Permissions.ACTIVITY_REPORT],
    //   },
    //   {
    //     to: "/redemption-catalog",
    //     defaultImage: "images/sidebar-icons/gift-catalog-not-selected.png",
    //     selectedImage: "images/sidebar-icons/gift-catalog-selected.png",
    //     title: "Redemption Catalogue",
    //     isActive: false,
    //     key: "Redemption Catalogue",
    //     permission: [Permissions.REDEMPTION_CATALOGUE],
    //   },
    //   {
    //     to: "/new-fleet-registration",
    //     defaultImage: "images/sidebar-icons/NewFleetRegistration.svg",
    //     selectedImage: "images/sidebar-icons/NewFleetRegistrationslected.svg",
    //     title: "New Fleet Registration",
    //     isActive: false,
    //     key: "New Fleet Registration",
    //     permission: [Permissions.NEW_FLEET_REGISTRATION],
    //   },
    //   {
    //     to: "/about",
    //     defaultImage: "images/sidebar-icons/about.svg",
    //     selectedImage: "images/sidebar-icons/about-selected.svg",
    //     title: "About Programme",
    //     isActive: false,
    //     key: "About Programme",
    //     permission: [Permissions.ABOUT_PROGRAMME_BAADSHAH],
    //   },
    //   {
    //     to: "/contact-us",
    //     defaultImage: "images/sidebar-icons/ContactUs.svg",
    //     selectedImage: "images/sidebar-icons/ContactsUsSelcted.svg",
    //     title: "Contact Us",
    //     isActive: false,
    //     key: "Contact Us",
    //     permission: [Permissions.CONTACT_US_BAADSHAH],
    //   }
    // ];

    // var badshahHeadOffice = [
    //   {
    //     to: "/dashboard",
    //     defaultImage: "images/sidebar-icons/ho-dashboard.svg",
    //     selectedImage: "images/sidebar-icons/ho-dashboard-selected.svg",
    //     title: "Dashboard",
    //     isActive: false,
    //     key: "Dashboard",
    //     permission: [Permissions.OFFTAKE_DASHBOARD_BAADSHAH],
    //   },
    //   {
    //     to: "/",
    //     defaultImage: "images/sidebar-icons/dashboard.svg",
    //     selectedImage: "images/sidebar-icons/dashboard-selected.svg",
    //     title: "Point Dashboard",
    //     isActive: false,
    //     key: "Point Dashboard",
    //     permission: [Permissions.POINTS_DASHBOARD_BAADSHAH],
    //   },
    //   {
    //     to: "/fleetDetails",
    //     defaultImage: "images/sidebar-icons/fleet-details.svg",
    //     selectedImage: "images/sidebar-icons/fleet-details-selected.svg",
    //     title: "Fleet Details",
    //     isActive: false,
    //     key: "Fleet Details",
    //     permission: [Permissions.FLEET_DETAIL],
    //   },
    //   {
    //     to: null,
    //     defaultImage: "images/sidebar-icons/download-scorecard.svg",
    //     selectedImage: "images/sidebar-icons/download-scorecard-selected.svg",
    //     title: "Download Scorecard",
    //     isActive: false,
    //     key: "Download Score Card",
    //     permission: [Permissions.DOWNLOAD_SCORECARD_BAADSHAH],
    //   },
    //   {
    //     to: null,
    //     defaultImage: "images/sidebar-icons/download-scorecard.svg",
    //     selectedImage: "images/sidebar-icons/download-scorecard-selected.svg",
    //     title: "Download Fleet Master",
    //     isActive: false,
    //     key: "Download Fleet Master",
    //     download_fleet_report: true,
    //     permission: [Permissions.DOWNLOAD_FLEET_MASTER],
    //   },
    //   {
    //     to: "/salesReport",
    //     defaultImage: "images/sidebar-icons/sales-report.svg",
    //     selectedImage: "images/sidebar-icons/sales-report-selected.svg",
    //     title: "Sales Report",
    //     isActive: false,
    //     key: "Sales Report",
    //     permission: [Permissions.SALES_REPORT],
    //   },
    //   {
    //     to: "/activity-report",
    //     defaultImage: "images/sidebar-icons/activity-report.svg",
    //     selectedImage: "images/sidebar-icons/activity-report-selected.svg",
    //     title: "Activity Report",
    //     isActive: false,
    //     key: "Activity Report",
    //     permission: [Permissions.ACTIVITY_REPORT],
    //   },
    //   {
    //     to: "/redemption-catalog",
    //     defaultImage: "images/sidebar-icons/gift-catalog-not-selected.png",
    //     selectedImage: "images/sidebar-icons/gift-catalog-selected.png",
    //     title: "Redemption Catalogue",
    //     isActive: false,
    //     key: "Redemption Catalogue",
    //     permission: [Permissions.REDEMPTION_CATALOGUE],
    //   },
    //   {
    //     to: "/about",
    //     defaultImage: "images/sidebar-icons/about.svg",
    //     selectedImage: "images/sidebar-icons/about-selected.svg",
    //     title: "About Programme",
    //     isActive: false,
    //     key: "About Program",
    //     permission: [Permissions.ABOUT_PROGRAMME_BAADSHAH],
    //   },
    //   {
    //     to: "/contact-us",
    //     defaultImage: "images/sidebar-icons/ContactUs.svg",
    //     selectedImage: "images/sidebar-icons/ContactsUsSelcted.svg",
    //     title: "Contact Us",
    //     isActive: false,
    //     key: "Contact Us",
    //     permission: [Permissions.CONTACT_US_BAADSHAH],
    //   }
    // ];

    if (this.state.navBarToHide && this.state.navBarToHide.length) {
      let result = mainMenuArr.filter(o1 => {
        return !this.state.navBarToHide.some(function (o2) {
          return o1.key === o2.key;
        });
      });
      mainMenuArr = result;
      // if (userRoleDetail.type.toLowerCase() === Roles.FLEET_MANAGER_ROLE) {
      //   let result = fleetManagerSideMenus.filter(o1 => {
      //     return !this.state.navBarToHide.some(function (o2) {
      //       return o1.key === o2.key;
      //     });
      //   });
      //   fleetManagerSideMenus = result;
      // } else if (userRoleDetail.type.toLowerCase() === Roles.ZONAL_FLEET_MANAGER_ROLE) {
      //   let result = zonalFleetManagerSideMenus.filter(o1 => {
      //     return !this.state.navBarToHide.some(function (o2) {
      //       return o1.key === o2.key;
      //     });
      //   });
      //   zonalFleetManagerSideMenus = result;
      // } else if (userRoleDetail.type.toLowerCase() === Roles.HEAD_OFFICE_BAADSHAH_ROLE) {
      //   let result = badshahHeadOffice.filter(o1 => {
      //     return !this.state.navBarToHide.some(function (o2) {
      //       return o1.key === o2.key;
      //     });
      //   });
      //   badshahHeadOffice = result;
      // } else {
      //   var result = fleetSideMenus.filter(o1 => {
      //     return !this.state.navBarToHide.some(function (o2) {
      //       return o1.key === o2.key;
      //     });
      //   });
      //   fleetSideMenus = result;
      // }
    }

    let finalMenu = [];
    let menusToShow = [];
    let permissions = [];
    if (userRoleDetail && userRoleDetail.permissions) {
      permissions = userRoleDetail.permissions;
    }

    let fleetArr = mainMenuArr;
    for (let i = 0; i < fleetArr.length; i++) {
      const currentMenu = fleetArr[i];
      let addMenu = false;
      if (currentMenu.permission && currentMenu.permission.length > 0) {
        for (let j = 0; j < currentMenu.permission.length; j++) {
          const currentPermission = currentMenu.permission[j];
          if (permissions.includes(currentPermission)) {
            addMenu = true;
            break;
          }
        }
      }
      if (addMenu === false) {
        continue;
      }
      const mainMenuObj = JSON.parse(JSON.stringify(currentMenu));
      finalMenu.push(mainMenuObj);
    }
    menusToShow = finalMenu;

    // if (userRoleDetail.type === Roles.FLEET_MANAGER_ROLE) {
    //   let fleetArr = fleetManagerSideMenus;
    //   for (let i = 0; i < fleetArr.length; i++) {
    //     const currentMenu = fleetArr[i];
    //     let addMenu = false;
    //     if (currentMenu.permission && currentMenu.permission.length > 0) {
    //       for (let j = 0; j < currentMenu.permission.length; j++) {
    //         const currentPermission = currentMenu.permission[j];
    //         if (permissions.includes(currentPermission)) {
    //           addMenu = true;
    //           break;
    //         }
    //       }
    //     }
    //     if (addMenu === false) {
    //       continue;
    //     }
    //     const mainMenuObj = JSON.parse(JSON.stringify(currentMenu));
    //     finalMenu.push(mainMenuObj);
    //   }
    //   menusToShow = finalMenu;
    //   // menusToShow = fleetManagerSideMenus;
    // } else if (userRoleDetail.type === Roles.ZONAL_FLEET_MANAGER_ROLE) {
    //   let fleetArr = zonalFleetManagerSideMenus;
    //   for (let i = 0; i < fleetArr.length; i++) {
    //     const currentMenu = fleetArr[i];
    //     let addMenu = false;
    //     if (currentMenu.permission && currentMenu.permission.length > 0) {
    //       for (let j = 0; j < currentMenu.permission.length; j++) {
    //         const currentPermission = currentMenu.permission[j];
    //         if (permissions.includes(currentPermission)) {
    //           addMenu = true;
    //           break;
    //         }
    //       }
    //     }
    //     if (addMenu === false) {
    //       continue;
    //     }
    //     const mainMenuObj = JSON.parse(JSON.stringify(currentMenu));
    //     finalMenu.push(mainMenuObj);
    //   }
    //   menusToShow = finalMenu;
    //   // menusToShow = zonalFleetManagerSideMenus;
    // } else if (userRoleDetail.type === Roles.HEAD_OFFICE_BAADSHAH_ROLE) {
    //   let fleetArr = badshahHeadOffice;
    //   for (let i = 0; i < fleetArr.length; i++) {
    //     const currentMenu = fleetArr[i];
    //     let addMenu = false;
    //     if (currentMenu.permission && currentMenu.permission.length > 0) {
    //       for (let j = 0; j < currentMenu.permission.length; j++) {
    //         const currentPermission = currentMenu.permission[j];
    //         if (permissions.includes(currentPermission)) {
    //           addMenu = true;
    //           break;
    //         }
    //       }
    //     }
    //     if (addMenu === false) {
    //       continue;
    //     }
    //     const mainMenuObj = JSON.parse(JSON.stringify(currentMenu));
    //     finalMenu.push(mainMenuObj);
    //   }
    //   menusToShow = finalMenu;
    //   // menusToShow = badshahHeadOffice;
    // } else if (userRoleDetail.type === Roles.FLEET_ROLE) {

    //   let fleetArr = fleetSideMenus;
    //   for (let i = 0; i < fleetArr.length; i++) {
    //     const currentMenu = fleetArr[i];
    //     let addMenu = false;
    //     if (currentMenu.permission && currentMenu.permission.length > 0) {
    //       for (let j = 0; j < currentMenu.permission.length; j++) {
    //         const currentPermission = currentMenu.permission[j];
    //         if (permissions.includes(currentPermission)) {
    //           addMenu = true;
    //           break;
    //         }
    //       }
    //     }
    //     if (addMenu === false) {
    //       continue;
    //     }
    //     const mainMenuObj = JSON.parse(JSON.stringify(currentMenu));
    //     finalMenu.push(mainMenuObj);
    //   }
    //   menusToShow = finalMenu;

    //   // menusToShow = fleetSideMenus;
    // }

    const currentPath = this.props.location.pathname;
    const locationIndex = menusToShow.findIndex(o => o.to === currentPath);

    if (locationIndex > -1) {
      menusToShow[locationIndex].isActive = true;
    }

    // const prepareSideNav = (menus) => menus.map(s =>
    //   <NavItem onClick={this.closeSidebar} key={s.key}>
    //     <NavLink activeClassName="sidenav-active" className="sidenav-link" to={s.to} isActive={() => s.isActive}>
    //       <span className="sidenav-icon-padding">
    //         <img src={s.isActive ? s.selectedImage : s.defaultImage} alt='' width="20px" height="20px" />
    //       </span>
    //       {s.title}
    //     </NavLink>
    //   </NavItem>
    // );

    const prepareSideNav = menus =>
      menus.map(s => {
        return s.to ? (
          <NavItem onClick={this.closeSidebar} key={s.key}>
            <NavLink
              className={({ isActive }) => `sidenav-link ${isActive ? "sidenav-active" : ""}`}
              to={s.to}
              style={{ fontSize: "15px" }}
            >
              <span className="sidenav-icon-padding">
                {!s.isChangeWidth && (
                  <img
                    src={s.isActive ? s.selectedImage : s.defaultImage}
                    width="20px"
                    height="20px"
                    alt=""
                  />
                )}
                {s.isChangeWidth && (
                  <img
                    src={s.isActive ? s.selectedImage : s.defaultImage}
                    style={{ height: "30px", width: "25px" }}
                    alt=""
                  />
                )}
              </span>
              {s.title}
            </NavLink>
          </NavItem>
        ) : (
          <span>
            {s.download_fleet_report ? (
              <NavItem onClick={this.downloadfleetreport} key={s.key} style={{ fontSize: "15px" }}>
                <div
                  // onClick={this.downloadScorecard}
                  className="sidenav-link"
                  style={downloadfleetScorecardStyle}
                  onMouseOver={this.downloadfleetScorecardMouseEvent.bind(
                    this,
                    true
                  )}
                  onMouseLeave={this.downloadfleetScorecardMouseEvent.bind(
                    this,
                    false
                  )}
                >
                  <span className="sidenav-icon-padding">
                    {!s.isChangeWidth && (
                      <img
                        src={s.isActive ? s.selectedImage : s.defaultImage}
                        width="20px"
                        height="20px"
                        alt=""
                      />
                    )}
                    {s.isChangeWidth && (
                      <img
                        src={s.isActive ? s.selectedImage : s.defaultImage}
                        style={{ height: "30px", width: "25px" }}
                        alt=""
                      />
                    )}
                  </span>
                  {s.title}
                </div>
              </NavItem>
            ) : (
              <NavItem onClick={this.openScorcardModel} key={s.key}>
                <div
                  // onClick={this.downloadScorecard}
                  className="sidenav-link"
                  style={{ ...downloadScorecardStyle, fontSize: "15px" }}
                  onMouseOver={this.downloadScorecardMouseEvent.bind(
                    this,
                    true
                  )}
                  onMouseLeave={this.downloadScorecardMouseEvent.bind(
                    this,
                    false
                  )}
                >
                  <span className="sidenav-icon-padding">
                    {!s.isChangeWidth && (
                      <img
                        src={s.isActive ? s.selectedImage : s.defaultImage}
                        width="20px"
                        height="20px"
                        alt=""
                      />
                    )}
                    {s.isChangeWidth && (
                      <img
                        src={s.isActive ? s.selectedImage : s.defaultImage}
                        style={{ height: "30px", width: "25px" }}
                        alt=""
                      />
                    )}
                  </span>
                  {s.title}
                </div>
              </NavItem>
            )}
          </span>
        );
      });

    return (
      <Fragment>
        {this.state.redirectToLoginPage && <Redirect to="/login" />}
        {this.state.isLoader && <CustomSpinner />}
        <LogoutModal
          show={this.state.isLogoutModalOpen}
          closeModal={this.closeLogoutModal}
          history={this.props.history}
        />
        {this.state.isScorCardOpen && (
          <DownloadScorcard
            ShowDownloadScorcard={this.state.isScorCardOpen}
            closeModal={this.closeScorcardModel}
            openModel={true}
          />
        )}

        <div
          className="sidebar-mobile-overlay"
          onClick={this.toggleMobileSidebar}
        />
        <CSSTransition
          in={true}
          appear={true}
          timeout={1500}
          classNames="SidebarAnimation"
          unmountOnExit>
          <div className={cx("app-sidebar", backgroundColor, {
            "sidebar-shadow": enableSidebarShadow
          })}>
          {/* <HeaderLogo /> */}
          <PerfectScrollbar options={{ wheelPropagation: true, suppressScrollX: true }}>
            <div className="app-sidebar__inner">
              <Fragment>
                {this.isMobile && (
                  <div className="side-nav-profile">
                    {userDetail ? (
                      <img
                        src={
                          userDetail.image_url
                            ? userDetail.image_url
                            : "images/Web_Avatar.svg"
                        }
                        height="50px"
                        width="auto"
                        className="side-nav-profile-img"
                        style={{ objectFit: "cover", borderRadius: "50.5px" }}
                        alt="Web_Avatar"
                      />
                    ) : (
                      <img
                        src="images/Web_Avatar.svg"
                        height="50px"
                        width="auto"
                        className="side-nav-profile-img"
                        alt="Web_Avatar"
                      />
                    )}
                    <div className="d-flex-column side-nav-profile-name-wrapp">
                      {userDetail && (
                        <span className="side-nav-profile-name">
                          {userDetail.owner_name}
                        </span>
                      )}
                      <NavLink
                        className={({ isActive }) => `side-nav-profile-view ${isActive ? "sidenav-active" : ""}`}
                        to="/profile"
                        onClick={this.closeSidebar}
                      >
                        <span className="side-nav-profile-view">
                          View Profile
                        </span>
                      </NavLink>
                    </div>
                  </div>
                )}
                <Nav vertical style={{ paddingLeft: "6px" }}>
                  {prepareSideNav(menusToShow)}

                  {/* <div className="logout cursor-pointer" onClick={this.logout}>
                    <img src="images/logout.svg" alt='logout' />
                  </div> */}
                  <NavItem className="logout" onClick={this.openLogoutModal}>
                    <div
                      activeClassName="sidenav-active"
                      className="logoutLink sidenav-link"
                      style={{ display: "flex" }}
                    >
                      <span className="sidenav-icon-padding">
                        <img
                          src="images/logout.svg"
                          width="20px"
                          height="20px"
                          alt="logout"
                        />
                      </span>
                      {this.isMobile && (
                        <span
                          className="logout-lbl"
                          style={{
                            display: this.isDisplayLogOut ? "none" : "block"
                          }}
                        >
                          Logout
                        </span>
                      )}
                      {!this.isMobile && (
                        <span className="logout-lbl">Logout</span>
                      )}
                    </div>
                  </NavItem>
                  {/* <NavItem>
                    <NavLink exact activeClassName="sidenav-active" className="sidenav-link" to="/warrantyRegistration">
                      <span className="sidenav-icon-padding">
                        <img src="images/detail.svg" width="26px" height="25px" alt='detail' />
                      </span>
                      Warranty Registration
                    </NavLink>
                  </NavItem> */}
                </Nav>
              </Fragment>
            </div>
          </PerfectScrollbar>
          <div
            className={cx("app-sidebar-bg", backgroundImageOpacity)}
            style={{
              backgroundImage: enableBackgroundImage
                ? `url(${backgroundImage})`
                : null
            }}
          />
          </div>
        </CSSTransition>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  enableBackgroundImage: state.ThemeOptions.enableBackgroundImage,
  enableSidebarShadow: state.ThemeOptions.enableSidebarShadow,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  backgroundColor: state.ThemeOptions.backgroundColor,
  backgroundImage: state.ThemeOptions.backgroundImage,
  backgroundImageOpacity: state.ThemeOptions.backgroundImageOpacity
  // userDetail: state.User.user,
});

const mapDispatchToProps = dispatch => ({
  setEnableMobileMenu: enable => dispatch(setEnableMobileMenu(enable))
  // setUserDetail: user => dispatch(setUserDetail(user)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AppSidebar));
